module.exports = __webpack_public_path__ + "static/media/menu19.018f1df5.jpg";